import {
  Button,
  ButtonGroup,
  Content,
  Dialog,
  Divider,
  Heading,
  useDialogContainer,
  TextField,
  Flex,
  Text,
} from "@adobe/react-spectrum";
import React, { useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import PropTypes from "prop-types";
import {
  error as ErrorToast,
  success as SuccessToast,
} from "@react/react-spectrum/Toast";
import { gtmhApi } from "../../../../api/gtmhApi";
import useUserProfile from "../../../../context/user-context";

export default function ApproveSubDialog({
  rowInfo,
  // status,
  refreshTable,
  isPageLoading,
  setPageLoading,
}) {
  const { user } = useUserProfile();
  const { authState } = useOktaAuth();

  const [approveRequest, setApproveRequest] = useState({
    sub_id: rowInfo?.sub_id,
    sub_name: rowInfo?.sub_name,
    parent_id: rowInfo?.parent_id || rowInfo?.sub_id,
    duns_number: rowInfo?.duns_number,
    domain: rowInfo?.domain,
    government: rowInfo?.government,
    diversified: rowInfo?.diversified,
    sanctioned: rowInfo?.sanctioned,
    comment: "",
    user_id: user?.userId,
    user_name: user?.name,
    status: "in-review",
  });

  const [errorMessage, setErrorMessage] = useState("");

  const dialog = useDialogContainer();

  const handleApprove = () => {
    setPageLoading(true);
    gtmhApi
      .approveSub(approveRequest, authState.accessToken)
      .then((data) => {
        if (data.results?.sub_id) {
          dialog.dismiss();
          refreshTable();
          setPageLoading(false);
          SuccessToast(
            `Successfully approved ${rowInfo.sub_name} (${rowInfo.sub_id})!`,
            {
              timeout: 5000,
            }
          );
        } else {
          setPageLoading(false);
          setErrorMessage(data.results?.error_payload.message);
        }
      })
      .catch((error) => {
        console.log("error");
        dialog.dismiss();
        setPageLoading(false);
        ErrorToast(error.response?.data?.message || "Error approving company", {
          timeout: 5000,
        });
      });
  };

  const handleCancel = () => {
    dialog.dismiss();
  };

  return (
    <Dialog>
      <Heading>{`Approve ${rowInfo.parent ? "Parent" : "Sub"}: ${
        rowInfo.sub_name
      } (${rowInfo.sub_id})`}</Heading>
      <Divider />
      <Content>
        {errorMessage !== "" && (
          <Text UNSAFE_style={{ color: "red" }}>{errorMessage}</Text>
        )}
        <Flex marginBottom="15px">
          Approval will move the company to the active status. Proceed to
          approve?
        </Flex>
        <TextField
          label="Comment"
          width="100%"
          onChange={(val) =>
            setApproveRequest({ ...approveRequest, comment: val })
          }
          marginTop="10px"
        />
      </Content>
      <ButtonGroup>
        <Button onPress={handleCancel} variant="secondary">
          Cancel
        </Button>
        <Button
          onPress={handleApprove}
          color="primary"
          variant="accent"
          isDisabled={isPageLoading}
        >
          Approve
        </Button>
      </ButtonGroup>
    </Dialog>
  );
}

ApproveSubDialog.propTypes = {
  rowInfo: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.array,
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object),
    ])
  ).isRequired,
  // status: PropTypes.string.isRequired,
  refreshTable: PropTypes.func.isRequired,
  setPageLoading: PropTypes.func.isRequired,
  isPageLoading: PropTypes.bool.isRequired,
};
